export default [
  "Embracing Sunshine...",
  "Under Moonlit Skies...",
  "Glimpses of Sunlight...",
  "Nighttime Cloud Ballet...",
  "In the Realm of Clouds...",
  "Raindrops on the Horizon...",
  "Ice Crystals Descend...",
  "Snowflakes Blanket the Earth...",
  "Whistling Winds Approach...",
  "Lost in the Mist...",
];
